import moment from "moment-timezone"
import { AutocompleteInput, AutocompleteInputProps } from "react-admin"

export const timezoneChoices = moment.tz.names().map((name) => ({ id: name, name }))

export const SelectTimezoneInput: React.FC<AutocompleteInputProps> = (props) => (
  <AutocompleteInput emptyValue={undefined} {...props} choices={timezoneChoices} />
)
